import { columnDisplayNames } from "../types";
import type { JobValidityStatus } from "./classifyJobValidity";
import type { JobIssue } from "./jobValidation";

/**
 * Build "Field Label: message" lines for a Job Overview card's chip tooltip.
 *
 * Only the BLOCKING issues the chip is actually counting are shown, so the line
 * count never diverges from the chip label: invalid issues when the status is
 * "errors", missing issues when "incomplete", nothing when "complete".
 */
export function formatBlockingIssueLines(issues: JobIssue[], status: JobValidityStatus): string[] {
	const kind = status === "errors" ? "invalid" : status === "incomplete" ? "missing" : null;
	if (!kind) return [];
	return issues.filter((i) => i.blocking && i.kind === kind).map((i) => `${columnDisplayNames[i.field]}: ${i.message}`);
}
